define('views/filter-modal-rent',["exports", "common", "controls/range", "controls/switcher-multi", "./filter-modal"], function (_exports, _common, _range, _switcherMulti, _filterModal) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _range = _interopRequireDefault(_range);
  _switcherMulti = _interopRequireDefault(_switcherMulti);
  _filterModal = _interopRequireDefault(_filterModal);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  var _default = _exports.default = _filterModal.default.extend({
    _initControls() {
      this._initBudget();
    },
    _finiControls() {
      this._finiBudget();
    },
    _initBudget() {
      if (this.budgetControl) {
        return;
      }
      this.budgetControl = this.el.querySelector('.control-budget');
      this.budgetRange = new _range.default(this.budgetControl.querySelector('.control-range'), {
        min: 0,
        model: this.listState,
        delayProp: 'budget$delay',
        max: 1000,
        maxProp: '_budget$max',
        step: 50,
        stepProp: '_budget$step',
        startProp: 'budget$start',
        startFmt: (value = 0) => (0, _common.formatPrice)(value),
        endProp: 'budget$end',
        endFmt: end => {
          var max = this.listState.get('_budget$max');
          if (end > 0 && end < max) {
            return (0, _common.formatPrice)(end);
          } else {
            var symbol = (0, _common.formatPrice)(0).replace('0', '');
            var str = (0, _common.formatPrice)(max);
            var p = str.indexOf(symbol);
            return p > 0 ? `${str.substring(0, p)}+${str.substring(p)}` : `${str}+`;
          }
        },
        dependencyProps: ['currency']
      });
      this.budgetControl.querySelector('.slider').style.width = '100%';
      this.bathrooms = new _switcherMulti.default(this.el.querySelector('.control-bedrooms'), {
        model: this.listState
      });
      this.bedrooms = new _switcherMulti.default(this.el.querySelector('.control-bathrooms'), {
        model: this.listState
      });
    },
    _finiBudget() {
      this.budgetRange.destroy();
    },
    _clickSwitchBtn({
      currentTarget: btn
    }) {
      if (btn.name === 'bedrooms' || btn.name === 'bathrooms') {
        this.listState.set(`${btn.name}$`, Number(btn.value));
      }
    }
  });
});//# sourceMappingURL=filter-modal-rent.js.map
;
